module.exports = __webpack_public_path__ + "img/caizilin.0569c00c.jpeg";